import { useState, type FormEvent } from "react";
import { Leaf, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { NEWS_COLORS } from "../constants/news.constants";
import { newsQuote, newsSubscribe } from "../data/newsContent";
import { ROUTE_PATHS } from "@/routes/routePaths";

export function NewsQuoteBar() {
  return (
    <div className="mt-12 flex items-start gap-3 rounded-2xl border border-gray-200 bg-white px-5 py-4 shadow-sm sm:items-center sm:px-6">
      <Leaf
        className="mt-0.5 h-5 w-5 shrink-0 sm:mt-0"
        style={{ color: NEWS_COLORS.primary }}
        aria-hidden
      />
      <p className="text-sm leading-relaxed text-gray-600">{newsQuote.text}</p>
    </div>
  );
}

export function NewsThankYouBanner() {
  return (
    <div
      className="mt-6 flex flex-col items-start justify-between gap-4 rounded-2xl px-5 py-5 sm:flex-row sm:items-center sm:px-6"
      style={{ backgroundColor: NEWS_COLORS.primary }}
    >
      <div className="flex items-start gap-3 text-white">
        <Leaf className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
        <p className="text-sm font-medium leading-relaxed">
          Thank you to the KR Bharat Conclave organizers and the community of
          innovators shaping India’s mobility future.
        </p>
      </div>
      <Link
        to={ROUTE_PATHS.ABOUT_DURI}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-sm font-semibold shadow-sm transition-opacity hover:opacity-95"
        style={{ color: NEWS_COLORS.primary }}
      >
        Learn More About Duri →
      </Link>
    </div>
  );
}

export function NewsSubscribeCta() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
  };

  return (
    <section
      className="mt-10 rounded-2xl px-5 py-6 sm:px-8 sm:py-8"
      style={{ backgroundColor: NEWS_COLORS.primary }}
    >
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between lg:gap-10">
        <div className="flex max-w-xl items-start gap-3 text-white">
          <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/15">
            <Mail className="h-5 w-5" aria-hidden />
          </span>
          <p className="text-sm leading-relaxed sm:text-base">
            {newsSubscribe.text}
          </p>
        </div>

        {submitted ? (
          <p
            className="rounded-full bg-white px-5 py-3 text-sm font-semibold"
            style={{ color: NEWS_COLORS.primary }}
            role="status"
          >
            Thanks — you’re on the list.
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex w-full max-w-md items-center gap-1 rounded-full bg-white p-1.5 shadow-sm"
          >
            <label htmlFor="news-subscribe-email" className="sr-only">
              Email
            </label>
            <input
              id="news-subscribe-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={newsSubscribe.placeholder}
              className="h-10 min-w-0 flex-1 rounded-full border-0 bg-transparent px-4 text-sm text-gray-900 outline-none placeholder:text-gray-400"
            />
            <button
              type="submit"
              className="h-10 shrink-0 rounded-full px-4 text-sm font-semibold transition-opacity hover:opacity-90"
              style={{
                backgroundColor: NEWS_COLORS.primarySoft,
                color: NEWS_COLORS.primary,
              }}
            >
              {newsSubscribe.button}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
